import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDocumentStore } from '../stores/documentStore';

export function LevelManager() {
  const { t } = useTranslation('panels');
  const { document: doc, addLevel, updateLevel, deleteLevel, pushHistory } = useDocumentStore();

  if (!doc) return null;

  const sortedLevels = Object.values(doc.organization.levels).sort((a, b) => a.order - b.order);

  const handleAdd = () => {
    const maxElev = sortedLevels.length > 0
      ? Math.max(...sortedLevels.map((l) => l.elevation)) + 3000
      : 0;
    pushHistory('Add level');
    addLevel({ name: `Level ${sortedLevels.length + 1}`, elevation: maxElev, height: 3000 });
  };

  const handleNameBlur = (levelId: string, value: string) => {
    if (!value.trim()) return;
    pushHistory('Rename level');
    updateLevel(levelId, { name: value.trim() });
  };

  const handleElevBlur = (levelId: string, value: string) => {
    const num = parseFloat(value);
    if (isNaN(num)) return;
    pushHistory('Edit level elevation');
    updateLevel(levelId, { elevation: num });
  };

  const handleDelete = (levelId: string) => {
    pushHistory('Delete level');
    deleteLevel(levelId);
  };

  return (
    <div className="level-manager">
      <div className="panel-header">
        <span className="panel-title">{t('levels.title', { defaultValue: 'Levels' })}</span>
        <button className="panel-action-btn" title={t('levels.addLevel', { defaultValue: 'Add level' })} onClick={handleAdd}>
          +
        </button>
      </div>
      <div className="level-manager-list">
        {sortedLevels.map((level) => (
          <div key={level.id} className="level-manager-row">
            <input
              type="text"
              className="level-name-input"
              defaultValue={level.name}
              onBlur={(e) => handleNameBlur(level.id, e.target.value)}
              placeholder={t('levels.levelName', { defaultValue: 'Level name' })}
            />
            <input
              type="number"
              className="level-elev-input"
              defaultValue={level.elevation}
              onBlur={(e) => handleElevBlur(level.id, e.target.value)}
              placeholder="0"
              title={t('levels.elevation', { defaultValue: 'Elevation (mm)' })}
            />
            <button
              className="level-delete-btn"
              title={t('levels.deleteLevel', { defaultValue: 'Delete level' })}
              onClick={() => handleDelete(level.id)}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
